"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = exports.ButtonIcon = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Button = _interopRequireDefault(require("../Button"));

var _styles = require("../Button/styles");

var _IconButton = _interopRequireDefault(require("./IconButton.sizes"));

var Icon = (0, _styledComponents.default)(_styles.FieldIcon).withConfig({
  componentId: "sc-mq2kie-0"
})([""]);
exports.Icon = Icon;
var ButtonIcon = (0, _styledComponents.default)(_Button.default).withConfig({
  componentId: "sc-mq2kie-1"
})(["", ""], function (_ref) {
  var _buttonSizes$size;

  var theme = _ref.theme,
      size = _ref.size;
  var btnSize = (_buttonSizes$size = _IconButton.default[size]) !== null && _buttonSizes$size !== void 0 ? _buttonSizes$size : _IconButton.default[theme.sizes.button];
  return (0, _styledComponents.css)(["padding-top:", "px;padding-right:", "px;padding-bottom:", "px;padding-left:", "px;", "{svg{width:", "px;height:", "px;}}"], btnSize.padding.top, btnSize.padding.right, btnSize.padding.bottom, btnSize.padding.left, Icon, btnSize.icon.width, btnSize.icon.height);
});
exports.ButtonIcon = ButtonIcon;